<template>
  <div class='employDetail'>

    <section class="banner inner-banner">
      <img :src="employList.img" />
    </section>
    <section class="section em-title w1200 flexbox">
      <div class="info-title">
        <h2>{{ employList.title }}</h2>
        <h3 class="flexbox">
          <span class="salary" data-name="元/月">{{ employList.salary }}</span>
          <span>经验：{{ employList.experience }}&emsp;|&emsp;学历：{{ employList.education }} </span>
          <span>招聘人数：{{employList.num}}人</span>
        </h3>
      </div>
    </section>
    <section class="section w1200 betweenbox align-start em-content">
      <div class="des-ul">
        <div class="em-des">
          <h4>职位描述</h4>
          <div v-for="(item,index) in employList.list" :key='index'>
            <p>{{ item.title }}</p>
            <p v-for="(itm,idx) in item.content" :key="idx">
              <span>{{ idx+1 }}.</span>{{itm.div}}
            </p>
          </div>
        </div>
        <div class="em-des betweenbox">
          <div class="des-info">
            <h4>所属部门</h4>
            <p>{{ employList.department }}</p>
          </div>
          <div class="des-info">
            <h4>职位类型</h4>
            <p>{{ employList.type }}</p>
          </div>
          <div class="des-info">
            <h4>工作地点</h4>
            <p>{{ employList.address }}</p>
          </div>
        </div>
        <p style="padding-top: 30px;text-align: center;">申请职位请将简历投递到market@yichaomedical.com  欢迎您的加入</p>
      </div>

      <div class="em-side">
        <div class="side-ul">
          <span class="flexbox side-name">公司基本信息</span>
          <span class="flexbox"><img src="../../assets/images/em-ico1.png">{{ employList.medicalEquipment }}</span>
          <span class="flexbox"><img src="../../assets/images/em-ico2.png">{{ employList.people }}</span>
          <span class="flexbox"><img src="../../assets/images/em-ico3.png">{{ employList.address1 }}</span>
          <span class="line"></span>
        </div>
        <div class="side-ul">
          <span class="flexbox side-name">岗位推荐</span>
          <span class="job-li" v-for="(item,index) in employList.postList" :key="index">
            <div @click="goDetail(item.name)">
              <strong>{{ item.name }}</strong>
              <font>{{ item.money }}</font>&ensp;经验：{{item.experience}}&ensp;|&ensp;学历：{{item.education}}
            </div>
          </span>
          <a class="more-a centerbox" @click="employMore()">查看更多</a>
          <span class="line"></span>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  metaInfo() {
    return {
      title: "医疗器械售后部经理-健新",
      meta: [
        { name: "keywords", content: "keyword1, keyword2, keyword3" },
        { name: "description", content: "Page description" },
      ],
    };
  },
  mounted() {
  },
  data() {
    return {
      employList:{}
    }
  },
  created() {
    let data = {
        Title: this.$route.query.title,
        ForumTypeCode: "jxRecruiters",
      };
    this.getEmployDetail(data)
  },
  methods: {
    getEmployDetail(data) {
      axios
        .post("api/Forum/GetDoc", { ...data })
        .then((res) => {
          if (res) {
           this.employList = JSON.parse(res.data.OutputData.Content)
          } else {
            this.$message({
              type: "error",
              message: "请求数据失败",
            });
          }
        });
    },
    employMore() {
      this.$router.replace({ name: 'jxRecruiters' })
    },
    goDetail(name){
      this.$router.push({
        name:"employDetail",
        query:{
            title:name
        }
      })
    },
  }
}
</script>

<style lang='less'>
@import "../../assets/less/base.less";
.employDetail {
  width: 100%;
  .more-a {
    border: 1PX solid #d2d2d2;
    color: #969696;
  }


  .banner {
    width: 100%;
    height: auto;
    img {
      max-width: 100%;
      border: none;
      font-size: 0;
      outline-width: 0PX;
      vertical-align: top;
      width: 100%;
      height: auto;
    }
  }
  .em-title {
    .info-title h2 {
      color: #333;
    }
    .info-title span {
      color: #666;
    }
    .info-title .salary {
      color: #FE6600;
    }
    .info-title .salary:after {
      content: attr(data-name);
      color: #666;
    }
  }
  .des-ul {
    .em-des {
      .des-info {
        text-align: center;
      }
      h4 {
        color: #333;
      }
      p {
        color: #666666;
        line-height: 2.5;
      }
    }
    .em-des:nth-child(2n) {
      border-bottom: 1PX solid #e5e5e5;
    }
    .en-btn {
      background: #007edd;
      color: #fff;
    }
  }





  .em-side {
    .side-ul {
      border: 1PX solid #e5e5e5;
      color: #666;
    }
    .side-name {
      color: #333;
    }
    .side-ul .line {
      width: 100%;
      height: 1PX;
      border: 1PX dashed #e5e5e5;
      display: block;
    }
    .side-ul .job-li {
      display: block;
    }
    .side-ul .job-li strong {
      display: block;
      color: #333;
    }
    .side-ul .job-li font {
      color: #FE6600;
    }
    .side-ul .more-a {
      width: 100%;
    }
  }





  @media only screen and (min-width: 960px) {
    .more-a {
      width: 150PX;
      height: 42PX;
      border-radius: 26PX;
      font-size: 16PX;
      margin-bottom: 60PX;
    }
    .banner {
      padding-top: 130PX;
    }
    .em-title {
      height: 200PX;
      .info-title h2 {
        font-size: 30PX;
        margin-bottom: 20PX;
      }
      .info-title span {
        font-size: 16PX;
        margin-right: 80PX;
      }
      .info-title .salary {
        font-size: 24PX;
      }
      .info-title .salary:after {
        font-size: 14PX;
      }
    }
    .des-ul {
      width: 710PX;
      margin-bottom: 40PX;
      margin-right: 40PX;
      .em-des {
        h4 {
          font-size: 20PX;
          margin-bottom: 16PX;
        }
        p {
          font-size: 16PX;
        }
      }
      .em-des {
        padding-bottom: 50PX;
      }
      .en-btn {
        width: 120PX;
        height: 40PX;
        border-radius: 20PX;
        font-size: 16PX;
        margin-top: 40PX;
      }
    }
    .em-side {
      width: 268PX;
      .side-ul {
        padding: 20PX 32PX;
        margin-bottom: 10PX;
        font-size: 14PX;
      }
      .side-ul span img {
        width: 16PX;
        margin-right: 5PX;
      }
      .side-ul span {
        margin-bottom: 20PX;
      }
      .side-name {
        font-size: 18PX;
      }
      .side-ul .job-li {
        margin-bottom: 20PX;
      }
      .side-ul .more-a {
        margin-bottom: 20PX;
        width: 100%;
        margin-bottom: 20PX;
      }
    }
  }


  @media screen and (max-width:959px) and (min-width:320px) {
    .banner {
      padding-top: 3.52rem;
    }
    .em-title {
      height: 10.8rem;
      .info-title h2 {
        font-size: 1.44rem;
        margin-bottom: .8rem;
      }
      h3 {
        -webkit-box-pack: justify;
        -moz-justify-content: space-between;
        -webkit-justify-content: space-between;
        justify-content: space-between;
        -moz-box-lines: multiple;
        -webkit-box-lines: multiple;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        -moz-flex-wrap: wrap;
      }
      .info-title span {
        font-size: .96rem;
        margin-right: 0;
      }
      .info-title .salary {
        font-size: 1.12rem;
        width: 100%;
        line-height: 1.7;
      }
      .info-title .salary:after {
        font-size: .96rem
      }
    }

    .des-ul {
      width: 100%; // width: 27.12rem;
      margin-bottom: 1.6rem;
      margin-right: 0;
      .em-des {
        h4 {
          font-size: 1.08rem;
          margin-bottom: .8rem;
        }
        p {
          font-size: 1.28rem; // font-family: monospace;
          line-height: 1.7;
        }
      }
      .em-des {
        padding-bottom: 2rem;
      }
      .en-btn {
        width: 7.2rem;
        height: 2.4rem;
        border-radius: 30PX;
        font-size: 0.96rem;
        margin-top: 1.6rem;
      }
    }

    .em-side {
      width: 100%;
      .side-ul {
        padding: .8rem 1.28rem;
        margin-bottom: .4rem;
        font-size: .96rem;
      }
      .side-ul span img {
        width: 16PX;
        margin-right: 5PX;
      }
      .side-ul span {
        margin-bottom: .8rem;
      }
      .side-name {
        font-size: 1.2rem;
      }
      .side-ul .job-li {
        margin-bottom: .8rem;
      }
      .side-ul .more-a {
        margin-bottom: .8rem;
      }
    }



    .em-content {
      -moz-box-lines: multiple;
      /*Firefox*/
      -webkit-box-lines: multiple;
      /*Safari,Opera,Chrome*/
      box-lines: multiple;
      flex-wrap: wrap;
      -webkit-flex-wrap: wrap;
      -moz-flex-wrap: wrap;
    }
  }
}
</style>